import { createRouter, createWebHistory } from 'vue-router'
import StartView from '../views/StartView.vue'
import SuccessView from '../views/SuccessView.vue'

const routes = [
  {
    path: '/',
    name: 'start',
    component: StartView
  },
  {
    path: '/thankyou',
    name: 'thankyou',
    component: SuccessView
  },
  {
    path: '/404', name: 'NotFound', 
  },
  {
      path: '/:catchAll(.*)', redirect:'404'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router